export const downloadUrl = (url: string, fileName?: string) => {
  if (!url) {
    return
  }

  const link = document.createElement('a')
  link.href = url
  link.download = fileName ?? 'downloaded_file'

  // Set attributes for opening in a new tab and security measures
  link.setAttribute('target', '_blank')
  link.setAttribute('rel', 'noopener noreferrer')

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
